export default __webpack_public_path__ + "static/media/columnHover.030e6880.svg";